import React from 'react';
import LanguageSelectorFooter from "./LanguageSelectorFooter";
import { CustomAccordion } from "./CustomAccordion";

const FooterLinks = ({ links }) => {
    return (
        <div className="footer__content">
            {
                links.map((x, index) => {
                    return (<section className="footer__list" key={index}>
                            <div className="footer__accordion-list">
                                <CustomAccordion
                                    header={<h2 className="footer__header accordion-toggle">{x.sectionTitle}</h2>}
                                    icon={
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21"
                                             viewBox="0 0 20 21" fill="none">
                                            <path d="M5 8.06836L10 13.0684L15 8.06836" stroke="#373D41" strokeWidth="2"
                                                  strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    }
                                    content={
                                        <div className="accordion-content">
                                            {
                                                x.sectionLinkList.map((link, linkIndex) => {
                                                    return (
                                                        <a className="footer__link" href={link.href}
                                                           key={linkIndex}>{link.text}</a>
                                                    );
                                                })
                                            }

                                            {x.sectionText?.value && <div
                                                dangerouslySetInnerHTML={{ __html: x.sectionText.value }}></div>}
                                        </div>
                                    }
                                >
                                </CustomAccordion>
                            </div>
                            <div className="footer__desktop-list">
                                <h2 className="footer__header accordion-toggle">{x.sectionTitle}</h2>
                                <div className="accordion-content">
                                    {
                                        x.sectionLinkList.map((link, linkIndex) => {
                                            return (
                                                <a className="footer__link" href={link.href}
                                                   key={linkIndex}>{link.text}</a>
                                            );
                                        })
                                    }

                                    {x.sectionText?.value && <div
                                        dangerouslySetInnerHTML={{ __html: x.sectionText.value }}></div>}
                                </div>
                                {index === 0 && <LanguageSelectorFooter/>}
                            </div>
                        </section>
                    )
                })
            }
            
            <LanguageSelectorFooter mobile/>
        </div>
    );
};

export default FooterLinks;
